import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';
import ArticlesListPage from '@features/articles/ArticlesListPage.tsx';
import UserLayout from '@components/layout/UserLayout.tsx';
import { z } from 'zod';
import { useArticlesStore } from '@features/articles/articlesStore.ts';

const articlesSearchSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
});

export type ArticlesSearchParams = z.infer<typeof articlesSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/articles/')({
  validateSearch: search => articlesSearchSchema.parse(search),
  beforeLoad: ctx => {
    const orgId = Number(ctx.params.orgId);
    const portalId = Number(ctx.params.portalId);
    const page = ctx.search.page ?? 1;
    const size = ctx.search.size ?? 20;

    useArticlesStore.getState().fetchArticles(orgId, portalId, page, size);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: 'Články', href: undefined }]} />
        <div className="flex items-center justify-between mb-2 mt-4">
          <h1 className="text-3xl font-bold text-main">Články</h1>
        </div>
        <p className="text-light">Přehled všech článků a důležitých informací</p>
      </div>

      <ArticlesListPage />
    </UserLayout>
  );
}
